import React from "react";
import img from "../assets/heroimg.jpeg"

export default function HeroSection() {
  return (
    <section className="relative min-h-screen bg-hero-gradient text-white overflow-hidden">
      {/* background overlay image */}
      <div
        className="absolute inset-0 opacity-35 mix-blend-screen"
        style={{
          backgroundImage: {img},
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />

      {/* subtle glow circles */}
      <div className="absolute -top-32 -left-24 w-72 h-72 bg-[#E34364]/30 blur-3xl rounded-full pointer-events-none" />
      <div className="absolute -bottom-40 right-0 w-80 h-80 bg-purple-700/40 blur-3xl rounded-full pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-4 md:px-8 pt-28 pb-16 flex flex-col lg:flex-row items-center gap-12">
        {/* Left: content */}
        <div className="flex-1 animate-fade-up">
          <div className="inline-flex items-center gap-2 bg-white/10 border border-white/20 px-4 py-1 rounded-full text-xs uppercase tracking-[0.18em] mb-4 backdrop-blur-lg shadow-lg">
            <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse" />
            Premium Photo Booth Experiences
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight drop-shadow-2xl">
            Capture Moments.
            <br />
            Create Memories.
            <br />
            <span className="text-[#E34364]">
              Elevate Every Event.
            </span>
          </h1>

          <p className="mt-4 text-base md:text-lg text-gray-200 max-w-xl">
            Photo booth rentals for private and corporate events. Our modern, interactive
            photo booths don’t just take pictures — they create experiences your guests
            will never forget.
          </p>

          <div className="mt-8 flex flex-wrap items-center gap-4">
            <a
              href="#contact"
              className="inline-flex items-center justify-center px-6 py-3 rounded-full bg-[#E34364] text-white font-semibold shadow-xl shadow-[#E34364]/40 hover:-translate-y-[2px] hover:shadow-[#E34364]/60 transition"
            >
              Get Started
            </a>
            <a
              href="#services"
              className="inline-flex items-center justify-center px-6 py-[11px] rounded-full border border-white/40 bg-white/5 text-sm md:text-base text-white hover:bg-white/15 transition"
            >
              View Packages
            </a>
          </div>

          {/* stats */}
          <div className="mt-8 flex flex-wrap gap-6 text-sm text-gray-200">
            <div className="flex items-center gap-3">
              <div className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center">
                🎉
              </div>
              <div>
                <div className="font-semibold">Weddings & Private Events</div>
                <div className="text-xs text-gray-300">Timeless keepsakes</div>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center">
                💼
              </div>
              <div>
                <div className="font-semibold">Corporate & Brands</div>
                <div className="text-xs text-gray-300">On-brand experiences</div>
              </div>
            </div>
          </div>
        </div>

        {/* Right: floating preview card */}
        <div className="flex-1 flex justify-center lg:justify-end">
          <div className="relative w-full max-w-md">
            {/* main card */}
            <div className="relative rounded-3xl bg-white/10 border border-white/20 shadow-2xl backdrop-blur-2xl p-4 md:p-5 animate-fade-up lg:translate-y-4">
              <div className="aspect-[3/4] rounded-2xl overflow-hidden relative">
                <img
                  src={img}
                  className="w-full h-full object-cover"
                  alt="PixlyBooth event"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent" />
                <div className="absolute bottom-4 left-4 right-4 flex items-center justify-between">
                  <div>
                    <p className="text-xs font-semibold text-gray-200 uppercase tracking-widest">
                      Live Event
                    </p>
                    <p className="text-sm font-semibold">
                      Guests sharing in real-time
                    </p>
                  </div>
                  <div className="bg-black/60 px-3 py-1 rounded-full text-xs flex items-center gap-1">
                    <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse" />
                    Online
                  </div>
                </div>
              </div>
            </div>

            {/* floating badge 1 */}
            <div className="absolute -top-4 -left-2 md:-left-6 animate-float-slow">
              <div className="bg-black/70 text-white text-xs md:text-sm px-4 py-2 rounded-2xl shadow-xl backdrop-blur-2xl border border-white/10 flex items-center gap-2">
                ⭐
                <span>“Everyone was obsessed with the booth!”</span>
              </div>
            </div>

            {/* floating badge 2 */}
            <div className="absolute bottom-4 -right-3 md:-right-6 animate-float-slow" style={{ animationDelay: "0.8s" }}>
              <div className="bg-[#E34364] text-white text-xs md:text-sm px-4 py-2 rounded-2xl shadow-xl flex flex-col">
                <span className="font-semibold">Instant Sharing</span>
                <span className="text-[11px] text-pink-100">
                  Photos • GIFs • Videos
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* scroll hint */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 hidden md:flex flex-col items-center text-xs text-gray-300">
        <span className="mb-1">Scroll to explore</span>
        <div className="w-[1px] h-10 bg-gray-500/70 relative overflow-hidden rounded-full">
          <div className="absolute inset-x-0 h-10 bg-gradient-to-b from-white to-transparent animate-[fadeUp_1.2s_ease-in-out_infinite]" />
        </div>
      </div>
    </section>
  );
}
